// RK26682 (2026-09-17). The cart payload is built from SAVED spots only, so
// anything sitting in the open spot editor is not added. Before this gate a
// customer could swap the photo in the editor, see the new photo everywhere on
// screen, tap "Add to cart" without pressing "Update spot", and get the OLD
// photo stitched. Three shirts on one order all received the first design.
//
// Rule: while the editor is open, add-to-cart is refused and the button says
// what to do. With no saved spot yet the existing "Finish your spot above"
// copy already covers it, so no label is returned for that case.
export function atcEditorBlock(opts: {
  draftOpen: boolean;
  savedSpotCount: number;
  editingExisting: boolean;
}): { blocked: boolean; label: string | null } {
  if (!opts.draftOpen) return { blocked: false, label: null };
  if (opts.savedSpotCount === 0) return { blocked: true, label: null };
  return {
    blocked: true,
    label: opts.editingExisting
      ? "Tap Update spot above first"
      : "Save your new spot above first",
  };
}
